export default __webpack_public_path__ + "static/media/info.34ca1610.svg";